export default __webpack_public_path__ + "static/4-893fbaebc2304fc5907a75d8deff61f6.webp";